import { useTranslation } from "react-i18next";
import { FaExclamationTriangle } from "react-icons/fa";
import type { TransNamespace } from "../types";

export type GeneralErrorProps = {
  className?: string;
};

export const GeneralError = (props: GeneralErrorProps) => {
  const { className = "" } = props;
  const { t } = useTranslation<TransNamespace>("esim:general-error");
  return (
    <div
      className={`mx-auto grid max-w-lg place-content-center place-items-center gap-y-9 text-center ${className}`}
    >
      <FaExclamationTriangle className="text-5xl" />
      <h1 className="text-3xl">{t("Oops, something went wrong!")}</h1>
      <p>
        {t(
          "We apologize for the inconvenience, but it seems like there was an error processing your request. Our team has been notified of the issue and is working to resolve it as soon as possible. Please try again later or contact us if the problem persists.",
        )}
      </p>
    </div>
  );
};
